import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { State } from "../../store/state";
import {
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Typography,
  Hidden,
} from "@material-ui/core";
import { Add as AddIcon, Remove as RemoveIcon } from "@material-ui/icons";
import * as consts from "../../consts";

export default function CardValue(props) {
  const [error, setError] = useState(null);

  useEffect(() => {
    if (props.cardValue && !isNaN(parseFloat(props.cardValue))) {
      if (props.cardValue < consts.MIN_CARD_VALUE) {
        setError({
          message: `Enter a value of $${consts.MIN_CARD_VALUE} or more`,
        });
      } else if (props.cardValue > consts.MAX_CARD_VALUE) {
        setError({
          message: `Enter a value of $${consts.MAX_CARD_VALUE} or less`,
        });
      } else {
        setError(null);
      }
    } else {
      setError({
        message: `Card value is required`,
      });
    }
  }, [props.cardValue]);

  return (
    <Grid
      item
      xs={12}
      container
      spacing={2}
      className={props.classes.cardvaluemain}
    >
      <Grid item xs={12}>
        <Typography
          variant="h5"
          color="primary"
          className={props.classes.cardvaluetitle}
        >
          Card Value
        </Typography>
      </Grid>
      <Grid item xs={12} md={5}>
        <Grid item xs={12} style={{ lineHeight: "56px" }}>
          <IconButton
            onClick={() => {
              if (props.cardValue > consts.MIN_CARD_VALUE) {
                props.onCardValueChanged(props.cardValue - 1);
              }
            }}
            className={props.classes.cardvaluebutton}
            aria-label="Subtract 1 from value"
          >
            <RemoveIcon fontSize="large" />
          </IconButton>
          <TextField
            className={props.classes.cardvalueinput}
            type="number"
            required={true}
            error={error ? true : false}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
            min={consts.MIN_CARD_VALUE}
            max={consts.MAX_CARD_VALUE}
            variant="outlined"
            value={props.cardValue}
            onChange={(event) => {
              props.onCardValueChanged(parseFloat(event.target.value));
            }}
          />
          <IconButton
            onClick={() => {
              if (props.cardValue < consts.MAX_CARD_VALUE) {
                props.onCardValueChanged(props.cardValue + 1);
              }
            }}
            className={props.classes.cardvaluebutton}
            aria-label="Add 1 from value"
          >
            <AddIcon fontSize="large" />
          </IconButton>
        </Grid>
        <Grid item xs={12} style={{ width: "190px", textAlign: "center" }}>
          {error ? (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Hidden xsDown>
        <Grid item container xs={12} md={7}>
          <Grid item xs={3}>
            <Button
              variant="outlined"
              className={props.classes.cardvalueautoOption}
              color={props.cardValue == 50 ? "primary" : "secondary"}
              onClick={() => {
                props.onCardValueChanged(50);
              }}
            >
              <Typography variant="h5">$50</Typography>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="outlined"
              className={props.classes.cardvalueautoOption}
              color={props.cardValue == 75 ? "primary" : "secondary"}
              onClick={() => {
                props.onCardValueChanged(75);
              }}
            >
              <Typography variant="h5">$75</Typography>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="outlined"
              className={props.classes.cardvalueautoOption}
              color={props.cardValue == 100 ? "primary" : "secondary"}
              onClick={() => {
                props.onCardValueChanged(100);
              }}
            >
              <Typography variant="h5">$100</Typography>
            </Button>
          </Grid>
          <Grid item xs={3}>
            <Button
              variant="outlined"
              className={props.classes.cardvalueautoOption}
              color={props.cardValue == 200 ? "primary" : "secondary"}
              onClick={() => {
                props.onCardValueChanged(200);
              }}
            >
              <Typography variant="h5">$200</Typography>
            </Button>
          </Grid>
        </Grid>
      </Hidden>
    </Grid>
  );
}
